<template>
  <div style="text-align: center;margin-bottom: 600px">
    智慧建筑
  </div>
</template>

<script>
export default {
  name: "building",
  components: {
  },
  data() {
    return {

    };
  },
  created() {},

  mounted() {

  }
};
</script>

<style lang="scss" scoped>

</style>